import { useEffect, useState } from 'react';
import ExitIntent from 'logic/utils/ExitIntent';

export const useExitIntent = () => {
  const [onExit, setOnExit] = useState(false);
  useEffect(() => {
    const removeExitIntent = ExitIntent({
      onExitIntent: () => {
        setOnExit(true);
      },
    });
    return () => {
      removeExitIntent();
    };
  });
  return { onExit, setOnExit };
};
